import axios from 'axios';

const axiosRefresh = axios.create({
  // baseURL: "https://hackprinceton-registration-25f70f11442b.herokuapp.com",
  withCredentials: true,
});

export default axiosRefresh;
